import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IPayer } from './payer'
import { ILineOfBusiness } from './lineOfBusiness'
import { ODataService } from 'common-services'

export interface IEntityGroupPlanProviderView extends IModelBase {
  Id: string
  PlanId: number
  PlanKey: string
  PlanName: IPayer
  ProviderId: number
  ProviderKey: string
  ProviderName: ILineOfBusiness
  FeeScheduleId: number
}

@Injectable()
export class EntityGroupPlanProviderViewODataService extends ODataService<IEntityGroupPlanProviderView> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'EntityGroupPlanProviderView'
  }
}
